import { MessageService } from 'primeng/primeng';
import { CardDefinition } from './../../models/loyalty-card-definition.model';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';
import { CardBatch } from '../../models/loyalty-card-batch.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class LoyaltyCardBatchService {

  private cache = new Map<string, CardBatch>();
  private cachedFields: Observable<any>;

  public baseUrl = '/koncentro-loyalty';

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(cardBatchId): Observable<CardBatch> {

    if (this.cache.has(cardBatchId)) {
      return Observable.of(this.cache.get(cardBatchId));
    }

    return this.http.get(this.baseUrl + '/card_batch/' + cardBatchId).map(res => {
      // this.cache.set(res.id);
      return res;
    });
  }

  getList(offset = null, limit = null, search?: Array<{ key: string, value: string }>): Observable<{ data: Array<CardBatch>, metadata: ListMetadata }>  {

    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    if (offset !== null) {
      params.set('offset', offset.toString());
    }
    if (limit !== null) {
      params.set('limit', limit.toString());
    }

    return this.http.get(this.baseUrl + '/card_batch/getCardBatchList?' + params.toString());
  }

  list(
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
  ): Observable<{ data: Array<CardBatch>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
 //   return this.http.getPaged(this.baseUrl + '/card_batch/getCardBatchList?' + params.toString());
    return this.http.getPaged(this.baseUrl + '/card_batch/getCardBatchList?' + params.toString().replace(/'/gi, "''"));
  }

  update(cardBatch: CardBatch): Observable<CardBatch> {
    return this.http.put(this.baseUrl + '/card_batch/' + cardBatch.id, cardBatch).map(res => {
      this.cache.delete(cardBatch.id);
      return res;
    });
  }

  create(cardBatch: CardBatch): Observable<CardBatch> {
    return this.http.post(this.baseUrl + '/card_batch/', cardBatch);
  }

  remove(cardBatchId): Observable<CardBatch> {
    return this.http.delete(this.baseUrl + '/card_batch/' + cardBatchId).map(res => {
      this.cache.delete(cardBatchId);
      this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      return res;
    });
  }
  recover(cardBatch) {    
    return this.http.put(this.baseUrl + "/card_batch/recover/" + cardBatch.id, cardBatch)
      .map(res => {
        this.cache.delete(cardBatch.id);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/CardBatchDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  readyDeploy(cardBatchId): Observable<CardBatch> {
    return this.http.put('/koncentro-api/internal/' + cardBatchId + '/setCardBatchStatus?status=READY_FOR_DEPLOY', null);
  }

  resetDeploy(cardBatchId): Observable<CardBatch> {
    return this.http.put(this.baseUrl + '/card_batch/resetBatch/' + cardBatchId, null);
  }
  verifyExistingCardBatch(cardBatch: CardBatch): Observable<any> {
    return this.http.put(this.baseUrl + '/card_batch/verifyExistingCardBatch', cardBatch);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-card-batch.service.ts